import type {
  AnalyticsEvent,
  AnalyticsEventParamsOf,
} from "@v2/features/infra/analytics/events";

import * as React from "react";

import { errorToast } from "@v1/components/designSystem/alert/Toast";
import { useLogAnalytics } from "@v2/hooks/useLogAnalytics";

type ErrorEventType = Extract<AnalyticsEvent["type"], `error.${string}`>;

export const useV1ErrorToast = () => {
  const logEvent = useLogAnalytics();

  return React.useCallback(
    (
      title: string,
      message: string,
      eventName: ErrorEventType,
      params?: AnalyticsEventParamsOf<ErrorEventType>,
    ) => {
      logEvent(eventName, params);
      return errorToast(title, message);
    },
    [logEvent],
  );
};
